import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function OrderCancelledPage() {
  return (
    <div className="grain bg-[#050505] min-h-screen">
      <Nav />
      <main className="pt-32 md:pt-40 pb-24 min-h-[70vh]">
        <div className="max-w-[900px] mx-auto px-6 md:px-12">
          <div
            data-testid="order-cancelled"
            className="border border-white/10 bg-white/[0.02] p-10 md:p-16"
          >
            <AlertCircle className="text-white/70 mb-6" size={40} strokeWidth={1.2} />
            <p className="eyebrow mb-3">Payment Cancelled</p>
            <h1 className="font-serif text-5xl md:text-7xl text-white leading-[0.95]">
              Order not placed.
            </h1>
            <p className="mt-6 text-neutral-400 text-base md:text-lg leading-relaxed max-w-lg">
              You cancelled the payment — nothing was charged. Your cart is
              still saved so you can pick up where you left off.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to="/checkout" className="btn-primary" data-testid="order-cancelled-retry">
                Return to Checkout <ArrowRight size={14} />
              </Link>
              <Link to="/shop" className="btn-ghost">Keep Shopping</Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
